export class FinancialOutDTO {
  sumBancontact?: number;
  balance?: number;
}
